import { SafRegistryError } from './errors';

/**
 * Error thrown for network-related issues
 */
export class SafNetworkError extends SafRegistryError {
	public constructor(message: string, cause?: Error) {
		super(`Network error: ${message}`, cause);
	}
}
